<template>
  <div v-if="tags && tags.length" class="review-tags">
    <button class="grey small review-tag" :class="{ filled: !value, outlined: value }" @click="resetFilters()">All Reviews</button>
    <button
      v-for="(tag, index) in visibleReviewTags"
      :key="index"
      class="grey small review-tag"
      :class="{ filled: value === tag, outlined: value !== tag }"
      @click="handleTagClick(tag)"
    >
      {{ tag }}
    </button>
    <template v-if="tags.length > maxVisibleTags">
      <div class="show-more-toggle"><a v-if="!toShowMoreTags" @click.passive="toShowMoreTags = true">See more topics</a></div>
    </template>
  </div>
</template>
<script>
export default {
  props: ['value', 'tags'],

  data() {
    return {
      maxVisibleTags: 6,
      toShowMoreTags: false,
    };
  },

  computed: {
    visibleReviewTags() {
      if (this.tags && !this.toShowMoreTags) {
        return this.tags.length > this.maxVisibleTags ? this.tags.slice(0, this.maxVisibleTags) : this.tags;
      }

      return this.tags;
    },
  },

  methods: {
    resetFilters() {
      this.$emit('input', null);
    },

    handleTagClick(tagId) {
      this.$emit('input', tagId);
    },
  },
};
</script>
<style lang="scss">
@import '~@article/pixel/dist/style/variables';

.review-tags {
  display: flex;
  max-width: 900px;
  flex-wrap: wrap;
  justify-content: flex-end;
  align-items: center;

  @media (max-width: $mobile-breakpoint - 1) {
    width: 100%;
    justify-content: flex-start;
  }

  .review-tag {
    margin-right: var(--space-1);
    margin-bottom: var(--space-1);
    margin-top: var(--space-1);
  }

  .show-more-toggle {
    margin-left: var(--space-1);
  }
}
</style>
